import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import LeftBar from './LeftBar';
import Dashnav from './Dashnav';
import { ShellProvider } from './ShellContext';

function AdminShell() {
  useEffect(() => {
    document.body.classList.add('app-shell-active');
    return () => {
      document.body.classList.remove('app-shell-active');
    };
  }, []);

  return (
    <ShellProvider isShellActive={true}>
      <div className="mainContainer adminShellRoot">
        <LeftBar forceRender />
        <div className="theMainContainer adminShellContent">
          <Dashnav forceRender />
          <Outlet />
        </div>
      </div>
    </ShellProvider>
  );
}

export default AdminShell;
